import {GroupType} from '@cypro/engine/database/schema'
import {useGetInfiniteUsers, UseGetInfiniteUsersConfig} from './use-get-infinite-users'

export function useGetInfiniteDoctors(config?: UseGetInfiniteUsersConfig) {
  return useGetInfiniteUsers({
    filters: {groupTypes: [GroupType.enum.DOCTOR]},
    sort: {field: 'lastName', dir: 'asc'},
    nameFormat: 'last-first',
    ...config,
  })
}
